import { useState } from "react";
import { toast } from "sonner";
import { Info, Plus, Copy } from "lucide-react";
import { useServices } from "@/lib/services";
import { ServiceForm } from "@/components/avisos/ServiceForm";
import { ItemActions } from "@/components/avisos/ItemActions";
import { BlinkDot } from "@/components/avisos/BlinkDot";

const GROUPS = [["panel", "Painel e APIs (SYSLOG)"], ["proxy", "Proxys"], ["whatsapp", "WhatsApp do atendimento"], ["other", "Outros serviços"]];
const copy = (t) => navigator.clipboard.writeText(t).then(() => toast.success("Copiado")).catch(() => toast.error("Não foi possível copiar"));

const Row = ({ it, onEdit }) => (
  <div data-testid={`info-row-${it.id}`} className="flex flex-wrap items-center gap-3 rounded-xl border border-[#1F293D] bg-[#111827] px-4 py-3">
    <div className="w-full min-w-0 sm:w-56">
      <div className="flex items-center gap-2 font-semibold text-white">{it.status.alert && <BlinkDot testid={`info-dot-${it.id}`} />}{it.label}</div>
      <div className="truncate text-xs text-slate-500">{[it.name, it.note, it.due_day ? `vence todo dia ${String(it.due_day).padStart(2, "0")}` : ""].filter(Boolean).join(" · ")}</div>
    </div>
    <code data-testid={`info-detail-${it.id}`} className="min-w-0 flex-1 break-all font-mono text-xs text-sky-200">{it.detail || "—"}</code>
    {it.detail && <button data-testid={`info-copy-${it.id}`} onClick={() => copy(it.detail)} title="Copiar"
      className="rounded-lg border border-sky-500/30 p-2 text-sky-300 transition-colors hover:bg-sky-500/10"><Copy className="h-3.5 w-3.5" /></button>}
    <ItemActions it={it} onEdit={onEdit} />
  </div>
);

export default function Informacoes() {
  const { items } = useServices();
  const [form, setForm] = useState(null);
  return (
    <div data-testid="informacoes-page" className="space-y-6">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div>
          <h1 className="flex items-center gap-2 text-3xl font-extrabold tracking-tight text-slate-100"><Info className="h-7 w-7 text-sky-400" /> Informações</h1>
          <p className="mt-1 text-sm text-slate-400">Serviços do dia a dia: proxys, números de WhatsApp e painéis</p>
        </div>
        <button data-testid="info-add" onClick={() => setForm({})} className="inline-flex items-center gap-2 rounded-xl bg-sky-500 px-4 py-2.5 text-sm font-bold text-slate-950 transition-transform hover:-translate-y-0.5">
          <Plus className="h-4 w-4" /> Novo item
        </button>
      </div>
      {GROUPS.map(([k, title]) => {
        const list = items.filter((i) => i.kind === k);
        return list.length > 0 && (
          <section key={k} data-testid={`info-group-${k}`} className="space-y-2">
            <h2 className="text-sm font-semibold uppercase tracking-wider text-slate-300">{title} <span className="text-slate-500">· {list.length}</span></h2>
            {list.map((it) => <Row key={it.id} it={it} onEdit={() => setForm(it)} />)}
          </section>
        );
      })}
      <ServiceForm open={!!form} item={form?.id ? form : null} onClose={() => setForm(null)} />
    </div>
  );
}
